<div class="sheet-format-delete-confirm" data-testid="sheet-format-delete-confirm-modal">
  <p class="sheet-format-delete-confirm-text">
    {{ 'labelPrinting.sheetFormatDelete.confirm' | translate: { name: formatName } }}
  </p>
  <p class="sheet-format-delete-confirm-warning">
    {{ 'labelPrinting.sheetFormatDelete.warning' | translate }}
  </p>
</div>